import React, { useEffect, useState } from 'react';
import ProductGrid from '../components/ProductGrid';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';

const SearchPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);

    // Extract query parameters
    const [searchQuery, setSearchQuery] = useState(queryParams.get('query') || '');
    const [category, setCategory] = useState(queryParams.get('category') || '');

    // Update state when URL changes
    useEffect(() => {
        setSearchQuery(queryParams.get('query') || '');
        setCategory(queryParams.get('category') || '');
    }, [location.search]);

    // Handle search input
    const handleSearch = (query) => {
        setSearchQuery(query);
        queryParams.set('query', query);
        navigate(`?${queryParams.toString()}`);
    };

    return (
        <Layout onSearch={handleSearch}>
            <div className="min-h-screen bg-gray-50">
                {/* Header Section */}
                <div className="bg-white border-b border-gray-200">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                        <div className="flex items-center gap-2 text-sm text-gray-600 mb-4">
                            <button
                                onClick={() => navigate('/')}
                                className="hover:text-gray-900 transition-colors"
                            >
                                Home
                            </button>
                            <span>/</span>
                            <span className="text-gray-900 font-medium">Search</span>
                            {searchQuery && (
                                <>
                                    <span>/</span>
                                    <span className="text-gray-900 font-medium">"{searchQuery}"</span>
                                </>
                            )}
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold text-gray-900 mb-2">
                                {searchQuery ? `Search Results for "${searchQuery}"` : 'Browse Products'}
                            </h1>
                            {searchQuery && (
                                <p className="text-gray-600">
                                    Find the best deals on your favorite products
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                {/* Product Grid */}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <ProductGrid searchQuery={searchQuery} category={category} />
                </div>
            </div>
        </Layout>
    );
};

export default SearchPage;